import React, { useState, useEffect } from 'react';
import api from '../api';
import Pagination from '../components/Pagination';

const CandidateManagement = () => {
    const [candidates, setCandidates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [totalPages, setTotalPages] = useState(0);
    const [totalElements, setTotalElements] = useState(0);

    useEffect(() => {
        const fetchProfiles = async () => {
            try {
                setLoading(true);
                const response = await api.get('/profiles', {
                    params: {
                        page: currentPage,
                        size: pageSize
                    }
                });
                setCandidates(response.data.content);
                setTotalPages(response.data.totalPages);
                setTotalElements(response.data.totalElements);
            } catch (error) {
                console.error("Error fetching profiles:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchProfiles();
    }, [currentPage, pageSize]);

    return (
        <div className="candidate-management">
            {/* <div className="filters-bar">
                <select className="filter-select">
                    <option value="">Tất cả công việc</option>
                    <option value="1">Nhân Viên Kỹ Thuật Chính Máy Lò Xo</option>
                </select>
                <select className="filter-select">
                    <option value="">Trạng thái</option>
                    <option value="New">Mới</option>
                    <option value="Reviewed">Đã xem</option>
                    <option value="Rejected">Từ chối</option>
                </select>
            </div> */}

            <div className="data-table-container">
                {loading ? (
                    <div>Loading...</div>
                ) : (
                    <table className="data-table">
                        <thead>
                            <tr>
                                <th>STT</th>
                                <th>Họ tên</th>
                                <th>Số điện thoại</th>
                                <th>Ngày sinh</th>
                            </tr>
                        </thead>
                        <tbody>
                            {candidates.map((profile, index) => (
                                <tr key={profile.id}>
                                    <td>{currentPage * pageSize + index + 1}</td>
                                    <td>
                                        <div style={{ fontWeight: 500 }}>{profile.name}</div>
                                    </td>
                                    <td>{profile.phone}</td>
                                    <td>{profile.dob}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
                <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    totalElements={totalElements}
                    pageSize={pageSize}
                    onPageChange={setCurrentPage}
                    onPageSizeChange={(size) => {
                        setPageSize(size);
                        setCurrentPage(0);
                    }}
                />
            </div>
        </div>
    );
};

export default CandidateManagement;
